export function Logo({ className = "", showText = true, textClass = "" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <svg width="38" height="38" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <defs>
          <linearGradient id="eGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#3b82f6" />
            <stop offset="55%" stopColor="#2563eb" />
            <stop offset="100%" stopColor="#1e3a8a" />
          </linearGradient>
        </defs>
        {/* camera-crop frame */}
        <path d="M6 16V9a3 3 0 0 1 3-3h7" stroke="#0f172a" strokeWidth="3.2" strokeLinecap="round" />
        <path d="M48 6h7a3 3 0 0 1 3 3v7" stroke="#0f172a" strokeWidth="3.2" strokeLinecap="round" />
        <path d="M6 48v7a3 3 0 0 0 3 3h7" stroke="#0f172a" strokeWidth="3.2" strokeLinecap="round" />
        <path d="M58 48v7a3 3 0 0 1-3 3h-7" stroke="#0f172a" strokeWidth="3.2" strokeLinecap="round" />
        {/* E */}
        <path d="M40 18H23a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h17M20 32h14" stroke="url(#eGrad)" strokeWidth="6.5" strokeLinecap="round" strokeLinejoin="round" />
        {/* sparkles */}
        <path d="M50 12l1.6 3.6L55 17l-3.4 1.4L50 22l-1.6-3.6L45 17l3.4-1.4L50 12z" fill="#3b82f6" />
        <path d="M56 22l.9 2 2 .9-2 .9-.9 2-.9-2-2-.9 2-.9.9-2z" fill="#60a5fa" />
      </svg>
      {showText && (
        <span className={`font-heading font-extrabold text-xl tracking-tight ${textClass}`}>
          <span className="brand-text">Ecroply</span>
          <span className="text-blue-600">AI</span>
        </span>
      )}
    </span>
  );
}
